export default "__VITE_ASSET__BkWIIkAN__"